import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ReadMoreIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReadMore",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.44 4.33c-.86 0-1.55.7-1.55 1.55v1.54c0 .28-.23.51-.52.52H5.63c-.29 0-.52-.23-.52-.52V5.76c0-.86-.7-1.56-1.56-1.56s-1.56.7-1.56 1.56v1.66c0 2 1.63 3.63 3.63 3.63h20.74c2 0 3.63-1.63 3.63-3.63V5.88c0-.87-.7-1.56-1.55-1.56ZM3.56 27.78c.86 0 1.56-.7 1.56-1.56v-1.54c0-.29.23-.52.51-.52h20.74c.29 0 .52.23.52.52v1.54c0 .86.7 1.55 1.55 1.55s1.55-.7 1.55-1.55v-1.54c0-2-1.63-3.63-3.63-3.63H5.63c-2 0-3.63 1.63-3.63 3.63v1.54c0 .86.69 1.56 1.55 1.56Zm2.6-13.09H3.44c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h2.72c.75 0 1.36-.61 1.36-1.36s-.61-1.36-1.36-1.36m22.48 0h-2.72c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h2.72c.75 0 1.36-.61 1.36-1.36s-.61-1.36-1.36-1.36m-14.98 0h-2.72c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h2.72c.75 0 1.36-.61 1.36-1.36s-.61-1.36-1.36-1.36m7.5 0h-2.72c-.75 0-1.36.61-1.36 1.36s.61 1.36 1.36 1.36h2.72c.75 0 1.36-.61 1.36-1.36s-.61-1.36-1.36-1.36"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.86 11.71H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.99a1.14 1.14 0 1 1 2.28 0v2.29c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V5.99a1.14 1.14 0 1 1 2.28 0v2.29c0 1.89-1.54 3.43-3.43 3.43ZM28.14 27.71c-.63 0-1.14-.51-1.14-1.14v-2.29c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v2.29a1.14 1.14 0 1 1-2.28 0v-2.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v2.29c0 .63-.51 1.14-1.14 1.14ZM6.43 17.43H4.14a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28M20.14 17.43h-2.28a1.14 1.14 0 1 1 0-2.28h2.28a1.14 1.14 0 1 1 0 2.28M13.29 17.43H11a1.14 1.14 0 1 1 0-2.28h2.29a1.14 1.14 0 1 1 0 2.28M27 17.43h-2.29a1.14 1.14 0 1 1 0-2.28H27a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};
ReadMoreIcon.displayName = 'ReadMoreIcon';